// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import 'src/tokens/index.css';*/
/*@import 'src/tokens/spacing.css';*/
/*@import 'src/tokens/shapes.css';*/
/*@import 'src/tokens/typography.css';*/


:host {
    font-family: var(--font-family), sans-serif;
    font-size: var(--p2-medium-font-size);
    color: var(--text-default);
}

label {
    font-family: var(--p2-medium-font-family);
    font-size: var(--p2-medium-font-size);
    letter-spacing: var(--p2-medium-letter-spacing);
    line-height: var(--p2-medium-line-height);
    font-weight: var(--p2-medium-font-weight);
    display: block;
    padding: var(--spacing-05) 0;
}



.swiftref-dropdown *,
.swiftref-dropdown *::before,
.swiftref-dropdown *::after {
    box-sizing: border-box;
}

.swiftref-dropdown {
    display: block;
    /*from figma*/
    min-width: var(--input-min-width);
    position: relative;
    cursor: default;
    /*width: fit-content;*/
}

.swiftref-dropdown swiftref-message {
    margin-top: var(--spacing-05);
}

.label-container {
    display: flex;
    align-items: center;
}
:host([kind="compact"]:not([label])) .label-container {
    display: none;
}
:host([kind="compact"]:not([message])) swiftref-message {
    display: none;
}



.swiftref-dropdown::after {
    border-bottom: 2px solid var(--icon-light);
    border-right: 2px solid var(--icon-light);
    content: "";
    display: block;
    height: 6px;
    pointer-events: none;
    position: absolute;
    right: var(--spacing-20);
    top: 50%;
    transform: translate(0, -65%) rotate(45deg);
    width: 6px;
}
.swiftref-dropdown:hover {
    cursor: pointer;
}

[role="combobox"] {
    align-items: center;
    background-color: var(--background-white);
    border: 1px solid var(--border-strong);
    border-radius: var(--spacing-05);
    display: flex;
    height: var(--spacing-50);
    /* more padding right to give more space for the caret */
    /* top | right | bottom | left */
    padding: var(--spacing-05) var(--spacing-40) var(--spacing-05) var(--spacing-10);
    text-align: left;
}

[role="combobox"]:empty::after {
    content: attr(data-placeholder) "";
    color: var(--text-placeholder);
    font-size: var(--p2-regular-font-size);
    font-family: var(--p2-regular-font-family), sans-serif;
}

:host(:not([disabled])) [role="combobox"]:focus {
    outline: 1px solid var(--border-focused);
}



/*options*/
[role="listbox"] {
    background-color: var(--background-white);
    border: 1px solid var(--border-light);
    border-radius: var(--spacing-05);
    display: none;
    max-height: 300px;
    overflow-y: auto;
    left: 0;
    position: absolute;
    top: 100%;
    /*width: auto;*/
    width: max-content;
    z-index: 100;
    margin-top: var(--spacing-05);
    box-shadow: var(--shadow-medium);
}

.open [role="listbox"] {
    display: block;
}

[role="option"] {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: var(--spacing-40);
    /* top | right | bottom | left */
    padding: 0 var(--spacing-40) 0 var(--spacing-20);
}



[role="option"]:hover {
    background-color: var(--accent-light-hover);
}

[role="option"][aria-selected="true"] {
    background-color: var(--accent-light-selected);
    position: relative;
}

[role="option"][aria-selected="true"]::after {
    border-bottom: 2px solid var(--text-light);
    border-right: 2px solid var(--text-light);
    content: "";
    height: 10px;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translate(0, -50%) rotate(45deg);
    width: 7px;
}


:host([kind="light"]) [role="combobox"] {
    border-color: transparent;
}
:host([kind="light"]) [role="combobox"]:focus {
    outline: none;
}
/*:host([kind="light"]) [role="listbox"] {*/
/*    border-color: transparent;*/
/*    box-shadow: none;*/
/*}*/
/*:host([kind="light"]) [role="option"][aria-selected="true"]::after {*/
/*    border: none;*/
/*}*/

:host([required]) label:not(.message)::after {
    content: "*";
    color: var( --text-error);
    left: var(--spacing-05);
    position: relative;
}


/* =============================================================================
   disabled state
   ===========================================================================*/
:host([disabled]){
    color: var(--text-disabled);
}
:host([disabled]) label,
:host([disabled]) swiftref-message {
    color: var(--text-disabled);
}
:host([disabled]) [role="combobox"] {
    background: var(--background-disabled);
    cursor: not-allowed;
}


`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/dropdown/style/index.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,oCAAoC;AACpC,mCAAmC;AACnC,uCAAuC;;;AAGvC;IACI,2CAA2C;IAC3C,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,+CAA+C;IAC/C,yCAAyC;IACzC,yCAAyC;IACzC,cAAc;IACd,4BAA4B;AAChC;;;;AAIA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;;;;AAIA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;IACX,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,QAAQ;IACR,2CAA2C;IAC3C,UAAU;AACd;AACA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,sCAAsC;IACtC,gCAAgC;IAChC,aAAa;IACb,yBAAyB;IACzB,wDAAwD;IACxD,gCAAgC;IAChC,gFAAgF;IAChF,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,sCAAsC;IACtC,sDAAsD;AAC1D;;AAEA;IACI,wCAAwC;AAC5C;;;;AAIA,UAAU;AACV;IACI,yCAAyC;IACzC,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,OAAO;IACP,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,gCAAgC;IAChC,gDAAgD;AACpD;;;;AAIA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2CAA2C;IAC3C,UAAU;AACd;;;AAGA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA,2CAA2C;AAC3C,iCAAiC;AACjC,wBAAwB;AACxB,IAAI;AACJ,uEAAuE;AACvE,oBAAoB;AACpB,IAAI;;AAEJ;IACI,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;AACtB;;;AAGA;;+EAE+E;AAC/E;IACI,2BAA2B;AAC/B;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,sCAAsC;IACtC,mBAAmB;AACvB","sourcesContent":["/*@import 'src/tokens/index.css';*/\n/*@import 'src/tokens/spacing.css';*/\n/*@import 'src/tokens/shapes.css';*/\n/*@import 'src/tokens/typography.css';*/\n\n\n:host {\n    font-family: var(--font-family), sans-serif;\n    font-size: var(--p2-medium-font-size);\n    color: var(--text-default);\n}\n\nlabel {\n    font-family: var(--p2-medium-font-family);\n    font-size: var(--p2-medium-font-size);\n    letter-spacing: var(--p2-medium-letter-spacing);\n    line-height: var(--p2-medium-line-height);\n    font-weight: var(--p2-medium-font-weight);\n    display: block;\n    padding: var(--spacing-05) 0;\n}\n\n\n\n.swiftref-dropdown *,\n.swiftref-dropdown *::before,\n.swiftref-dropdown *::after {\n    box-sizing: border-box;\n}\n\n.swiftref-dropdown {\n    display: block;\n    /*from figma*/\n    min-width: var(--input-min-width);\n    position: relative;\n    cursor: default;\n    /*width: fit-content;*/\n}\n\n.swiftref-dropdown swiftref-message {\n    margin-top: var(--spacing-05);\n}\n\n.label-container {\n    display: flex;\n    align-items: center;\n}\n:host([kind=\"compact\"]:not([label])) .label-container {\n    display: none;\n}\n:host([kind=\"compact\"]:not([message])) swiftref-message {\n    display: none;\n}\n\n\n\n.swiftref-dropdown::after {\n    border-bottom: 2px solid var(--icon-light);\n    border-right: 2px solid var(--icon-light);\n    content: \"\";\n    display: block;\n    height: 6px;\n    pointer-events: none;\n    position: absolute;\n    right: var(--spacing-20);\n    top: 50%;\n    transform: translate(0, -65%) rotate(45deg);\n    width: 6px;\n}\n.swiftref-dropdown:hover {\n    cursor: pointer;\n}\n\n[role=\"combobox\"] {\n    align-items: center;\n    background-color: var(--background-white);\n    border: 1px solid var(--border-strong);\n    border-radius: var(--spacing-05);\n    display: flex;\n    height: var(--spacing-50);\n    /* more padding right to give more space for the caret */\n    /* top | right | bottom | left */\n    padding: var(--spacing-05) var(--spacing-40) var(--spacing-05) var(--spacing-10);\n    text-align: left;\n}\n\n[role=\"combobox\"]:empty::after {\n    content: attr(data-placeholder) \"\";\n    color: var(--text-placeholder);\n    font-size: var(--p2-regular-font-size);\n    font-family: var(--p2-regular-font-family), sans-serif;\n}\n\n:host(:not([disabled])) [role=\"combobox\"]:focus {\n    outline: 1px solid var(--border-focused);\n}\n\n\n\n/*options*/\n[role=\"listbox\"] {\n    background-color: var(--background-white);\n    border: 1px solid var(--border-light);\n    border-radius: var(--spacing-05);\n    display: none;\n    max-height: 300px;\n    overflow-y: auto;\n    left: 0;\n    position: absolute;\n    top: 100%;\n    /*width: auto;*/\n    width: max-content;\n    z-index: 100;\n    margin-top: var(--spacing-05);\n    box-shadow: var(--shadow-medium);\n}\n\n.open [role=\"listbox\"] {\n    display: block;\n}\n\n[role=\"option\"] {\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    height: var(--spacing-40);\n    /* top | right | bottom | left */\n    padding: 0 var(--spacing-40) 0 var(--spacing-20);\n}\n\n\n\n[role=\"option\"]:hover {\n    background-color: var(--accent-light-hover);\n}\n\n[role=\"option\"][aria-selected=\"true\"] {\n    background-color: var(--accent-light-selected);\n    position: relative;\n}\n\n[role=\"option\"][aria-selected=\"true\"]::after {\n    border-bottom: 2px solid var(--text-light);\n    border-right: 2px solid var(--text-light);\n    content: \"\";\n    height: 10px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translate(0, -50%) rotate(45deg);\n    width: 7px;\n}\n\n\n:host([kind=\"light\"]) [role=\"combobox\"] {\n    border-color: transparent;\n}\n:host([kind=\"light\"]) [role=\"combobox\"]:focus {\n    outline: none;\n}\n/*:host([kind=\"light\"]) [role=\"listbox\"] {*/\n/*    border-color: transparent;*/\n/*    box-shadow: none;*/\n/*}*/\n/*:host([kind=\"light\"]) [role=\"option\"][aria-selected=\"true\"]::after {*/\n/*    border: none;*/\n/*}*/\n\n:host([required]) label:not(.message)::after {\n    content: \"*\";\n    color: var( --text-error);\n    left: var(--spacing-05);\n    position: relative;\n}\n\n\n/* =============================================================================\n   disabled state\n   ===========================================================================*/\n:host([disabled]){\n    color: var(--text-disabled);\n}\n:host([disabled]) label,\n:host([disabled]) swiftref-message {\n    color: var(--text-disabled);\n}\n:host([disabled]) [role=\"combobox\"] {\n    background: var(--background-disabled);\n    cursor: not-allowed;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
